import { flippedTheme, useTheme } from "@/lib/theme";
import { useCallback } from "react";

export function useThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();

  const toggleTheme = useCallback(() => {
    setTheme(flippedTheme());
  }, [setTheme]);

  return {
    theme,
    resolvedTheme,
    toggleTheme,
    isDark: resolvedTheme === "dark",
  };
}
